import { createFileRoute } from "@tanstack/react-router";
import AdminStartupDetail from "@/pages/AdminStartupDetail";

export const Route = createFileRoute("/admin/accelerator/startup/$id/")({
  component: AdminStartupDetail,
});
